import 'zone.js';

// AWS SDK requirements
(window as any).global = window;
